import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { mdiSvgAliases, mdiSvgSet } from './mdi-svg'

/**
 * linQforce Farbpalette (aus dem Logo abgeleitet):
 * primary   #0B86C8   (kräftiges Blau)
 * secondary #60B7E6   (helleres Blau)
 * accent    #A7D3F2   (Pastell/Highlight)
 * surface   #FFFFFF
 * info      #2A9DF4   (optional)
 */
export const vuetify = createVuetify({
	icons: { defaultSet: 'mdi', aliases: mdiSvgAliases, sets: { mdi: mdiSvgSet } },
	theme: {
		defaultTheme: 'light',
		themes: {
			light: {
				dark: false,
				colors: {
					primary:   '#0B86C8',
					secondary: '#60B7E6',
					accent:    '#A7D3F2',
					surface:   '#FFFFFF',
					info:      '#2A9DF4'
				},
			},
		},
	},
})
